export const findDriverControllerEndpoint = (vehicleControllerEmail: string): string => {
  const query = new URLSearchParams({ vehicle_controller_email: vehicleControllerEmail })
  return `/berths/bookings/find_driver_controller?${query.toString()}` as const
}
